import { CSSObject } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getSupportTicketsTableSpinnerStyles = (theme: Theme): CSSObject => ({
    display: 'flex',
    justifyContent: 'center',
    minHeight: theme.spacing(40),
    padding: theme.spacing(3),
});
